module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "shades col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-xs-12 shades-list"
  }, [_c('div', {
    staticClass: "shades-list-items row"
  }, [(_vm.getShades.meta) ? _c('div', {
    staticClass: "result"
  }, [_c('p', {
    directives: [{
      name: "html-safe",
      rawName: "v-html-safe",
      value: (_vm.$t('shades.msgResultSearch').replace('{result}', _vm.getShades.meta.total)),
      expression: "$t('shades.msgResultSearch').replace('{result}', getShades.meta.total)"
    }],
    staticClass: "resultText"
  })]) : _vm._e(), _vm._v(" "), (_vm.getShades.meta) ? _c('div', {
    staticClass: "shades-list-pagination"
  }, [_c('Pagination', {
    attrs: {
      "componentName": 'Shades',
      "meta": _vm.getShades.meta,
      "page": _vm.currentPage
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('ListShades', {
    attrs: {
      "dataShades": _vm.getShades.data,
      "isLoader": _vm.loader
    }
  }), _vm._v(" "), (_vm.getShades.meta) ? _c('div', {
    staticClass: "shades-list-pagination"
  }, [_c('Pagination', {
    attrs: {
      "componentName": 'Shades',
      "meta": _vm.getShades.meta,
      "page": _vm.currentPage
    }
  })], 1) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-md-3 col-xs-12 shades-searchBar"
  }, [_c('div', {
    staticClass: "shades-searchBar-menu"
  }, [_vm._v("-------")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2ec7cd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shades/Shades.vue
// module id = 3359
// module chunks = 0